import { useRef, useCallback } from "react";
import { useSelector, useDispatch } from 'react-redux';
import type { ToastrEmitter } from "react-redux-toastr";

import { open as setOpenLoading, close as setCloseLoading } from 'store/reducers/loading';

type Ref = {
  current?: NodeJS.Timeout | null;
  id?: number | null;
}

type WithLoading = {
  loading: {
    isLoading: boolean;
  }
}

const useLoading = (toastr: ToastrEmitter) => {
  const closer: Ref = useRef();
  const dispatch = useDispatch();
  const isLoading = useSelector((state: WithLoading) => state.loading.isLoading)

  const closeLoading = useCallback(() => {
    closer?.current && clearTimeout(closer.current);
    return dispatch(setCloseLoading())
  }, [dispatch, closer]);

  const openLoading = useCallback((message: string) => {
    closer.current = setTimeout(() => {
      if (isLoading) {
        toastr.warning('', 'There is one problem, please reload the page');
      }
      closeLoading();
    }, 360000);
    return dispatch(setOpenLoading(message))
  }, [dispatch, closeLoading, isLoading, toastr]);

  return { openLoading, closeLoading };
}

export default useLoading;
